<template>
  <form @submit.prevent="nextStep">
    <div class="form-group registration-steps">
      <span class="badge badge-secondary p-2">1</span>
      - - -
      <span class="badge badge-secondary p-2">2</span>
      - - -
      <span class="badge badge-warning p-2">3 - Inloggegevens</span>
    </div>

    <div class="form-group">
      <label for="email">E-mailadres</label>
      <input
        id="email"
        type="email"
        class="form-control"
        :class="{'is-invalid': $v.email.$error, 'is-valid': !$v.email.$error && $v.email.$dirty}"
        v-model.lazy="email"
        @blur="$v.email.$touch()"
        autocomplete="email"
      >
      <span v-if="!$v.email.email || !$v.email.required" class="invalid-feedback" role="alert">
        <strong>Dit is geen geldig e-mailadres.</strong>
      </span>
      <span v-if="!$v.email.unique" class="invalid-feedback" role="alert">
        <strong>
          Uw e-mailadres is al bekend.<br/>
          <span @click="login" class="link underline">Klik hier om in te loggen</span> of <span @click="forgotPassword" class="link underline">klik hier om een nieuw wachtwoord aan te vragen om te kunnen inloggen</span>
        </strong>
      </span>
    </div>

    <div class="form-group">
      <label for="password">Wachtwoord</label>
      <input
        id="password"
        type="password"
        class="form-control"
        :class="{'is-invalid': $v.password.$error, 'is-valid': !$v.password.$error && $v.password.$dirty}"
        v-model="password"
        @blur="$v.password.$touch()"
      >
      <span v-if="!$v.password.minLen" class="invalid-feedback" role="alert">
        <strong>Uw wachtwoord moet tenminste {{ $v.password.$params.minLen.min }} karakters bevatten.</strong>
      </span>
    </div>

    <div class="form-group">
      <label for="confirm-password">Bevestig wachtwoord</label>
      <input
        id="confirm-password"
        type="password"
        class="form-control"
        :class="{'is-invalid': $v.confirmPassword.$error, 'is-valid': !$v.confirmPassword.$error && $v.confirmPassword.$dirty}"
        v-model="confirmPassword"
        @blur="$v.confirmPassword.$touch()"
      >
      <span v-if="!$v.confirmPassword.error" class="invalid-feedback" role="alert">
        <strong>Zorg er voor dat beide wachtwoorden gelijk zijn.</strong>
      </span>
    </div>

    <div class="form-group">
      <div class="form-check">
        <input
          id="terms"
          type="checkbox"
          class="form-check-input"
          :class="{'is-invalid': $v.terms.$error, 'is-valid': !$v.terms.$error && $v.terms.$dirty}"
          v-model="terms"
          @change="$v.terms.$touch()"
        >
        <label class="form-check-label terms-label" for="terms">
          Ik ga akkoord met de <a href="/pdf/algemene_voorwaarden_oldevuuren.pdf" target="_blank" class="link underline">algemene voorwaarden</a>
          van Oldevuuren
        </label>
        <div v-if="$v.terms.$invalid" class="invalid-feedback">
          Je moet akkoord gaan met de voorwaarden!
        </div>
      </div>
    </div>

    <div
      v-if="registerStatus"
      class="col-md-13 alert"
      role="alert"
      :class="{ 'alert-success': registerStatus.success, 'alert-danger': !registerStatus.success }"
    >
      <strong>{{ registerStatus.message }}</strong>
    </div>

    <div class="row justify-content-center mt-md-5">
      <div class="col-md-13">
        <button
          type="submit"
          class="btn btn-oldevuuren w-100 btn-round"
          :disabled="$v.$invalid"
          :class="{'disabled cursor-not-allowed': $v.$invalid}"
        >
          Aanmelding voltooien
          <font-awesome-icon class="font-awesome-icon" v-if="registerBusy" icon="spinner" spin/>
        </button>
      </div>

      <div class="row align-content-center mt-md-2">
        <div class="col-md-13">
          <span class="link" @click="previousStep"><font-awesome-icon class="font-awesome-icon" icon="chevron-left"/> Terug</span>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
  import axios from 'axios'
  import { email, minLength, required, sameAs } from 'vuelidate/lib/validators'
  import { SAVE_REGISTRATION_DATA, REGISTER } from '../../../store/types'

  export default {
    props: ['loginParent', 'forgotPasswordParent', 'nextStepParent', 'previousStepParent'],
    data() {
      return {
        email: '',
        password: '',
        confirmPassword: '',
        terms: false
      }
    },
    validations: {
      email: {
        required,
        email,
        unique: val => {
          if (val === '') return true

          return axios
            .post('/auth/check-email', {
              email: val
            })
            .then(res => {
              return !res.data.user_exists
            })
        }
      },
      password: {
        required,
        minLen: minLength(8)
      },
      confirmPassword: {
        sameAs: sameAs(vm => {
          return vm.password
        })
      },
      terms: {
        sameAs: sameAs(() => true)
      }
    },
    computed: {
      registerStatus() {
        return this.$store.getters.registerStatus
      },
      registerBusy() {
        return this.$store.getters.registerBusy
      }
    },
    methods: {
      login() {
        this.loginParent()
      },
      forgotPassword() {
        this.forgotPasswordParent()
      },
      nextStep() {
        // Save registration data
        this.$store.dispatch(SAVE_REGISTRATION_DATA, {
          key: 'loginDetails',
          formData: {
            email: this.email,
            password: this.password
          }
        })

        this.$store.dispatch(REGISTER)
      },
      previousStep() {
        // Save registration data
        this.$store.dispatch(SAVE_REGISTRATION_DATA, {
          key: 'loginDetails',
          formData: {
            email: this.email,
            password: this.password
          }
        })

        this.previousStepParent()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .terms-label {
    text-transform: none;
  }
</style>
